module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/2_83fb796f163e1e2fea61e7d281c8d278.jpg";